import React from "react";
import ReactDOM from "react-dom";
import { markdown } from "markdown";

export class BaseChunk extends React.Component {
  MAX_EDITOR_ROWS = 25;

  static defaultProps = {
    supportsMarkdown: false,
    saveLabel: false,
    canDelete: false,
  };

  mdRegex = {
    bold: new RegExp("\\*\\*(.*?)\\*\\*", "ig"),
    italics: new RegExp("\\*(.*?)\\*", "ig"),
    paragraph: new RegExp("\\n\\n", "ig"),
    list: new RegExp("[*+-]|\\d+\\.", "ig"),
    link: /^\[.+\]\(https?:\/\/.+\)$/gi,
  };

  bbCodeRegex = {
    italics: new RegExp("(\\[i])|(\\[/i])", "ig"),
    bold: new RegExp("(\\[b])|(\\[/b])", "ig"),
  };

  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  // ===============  REACT STUFF
  // propTypes: {
  //   supportsMarkdown: React.PropTypes.bool,
  //   field: React.PropTypes.string,
  //   model: React.PropTypes.object,
  //   help: React.PropTypes.string,
  //   label: React.PropTypes.string,
  // },
  setMyInputRef = (element) => {
    this.myInputRef = element;
  };

  componentDidUpdate() {
    if (this.state.isEditing && this.myInputRef.current) {
      const el = this.myInputRef.current;
      if (document.activeElement === el) {
        return;
      }
      el.selectionStart = el.selectionEnd = el.value.length;
      return el.focus();
    }
  }
  // =============== END REACT STUFF

  // =============== START CUSTOM STUFF

  capitalizeFirstLetter(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }

  deleteClick() {
    if (this.containerRef.current) {
      this.containerRef.current.classList.add("deleting");
    }
    
    // Use the onDelete callback if provided
    if (this.props.onDelete && this.props.model.id) {
      return this.props.onDelete(this.props.model.id);
    }
  }

  resizeEditor(textarea) {
    var height;
    //@TODO: Call this on a delay, since it might be expensive!
    // thanks to http://perplexed.co.uk/596_expanding_textarea_as_you_type.htm
    while (textarea.rows > 1 && textarea.scrollHeight < textarea.offsetHeight) {
      textarea.rows--;
    }
    if (textarea.rows < this.MAX_EDITOR_ROWS) {
      height = 0;
      while (
        textarea.scrollHeight > textarea.offsetHeight &&
        height !== textarea.offsetHeight
      ) {
        height = textarea.offsetHeight;
        textarea.rows++;
      }
    }
    return (textarea.rows = Math.min(textarea.rows, this.MAX_EDITOR_ROWS));
  }

  startEdit() {
    return this.setState({
      isEditing: true,
    });
  }

  onEditEnd() {
    return this.closeEditor(true);
  }

  closeEditor(save) {
    let newValue = this.state.rawContent;
    this.setState({ isEditing: false });

    if (save) {
      const oldValue = this.props.model[this.props.field];
      if (newValue !== oldValue) {
        // process markdown if it's needed
        newValue = this.bbCodeToMarkdown(newValue);
        const newContent = this.inputToMarkdown(newValue);
        // no id, this item is probably still saving
        this.props.model[`${this.props.field}`] = newValue;

        if (this.props.onChange) {
          const { model, field } = this.props;
          this.props.onChange({ model, field });
        }

        return this.setState({
          content: newContent,
        });
      }
    }
  }

  bbCodeToMarkdown(input) {
    if (this.props.supportsMarkdown) {
      input
        .replace(this.bbCodeRegex.bold, "**")
        .replace(this.bbCodeRegex.italics, "*");
    }
    return input;
  }

  // Simple bold and italics conversion
  inputToMarkdown(input) {
    if (input) {
      if (this.props.supportsMarkdown) {
        return markdown.toHTML(this.bbCodeToMarkdown(input));
      } else {
        return input;
      }
    }
    return "";
  }

  // Enable [Enter] key functionality for singleLine inputs
  onKeyDown(event) {
    switch (event.keyCode) {
      case 13: // enter key
        if (this.props.singleLine) {
          event.preventDefault();
          return this.closeEditor(true);
        }
    }
  }

  // Enable resizing and [Esc] key functionality
  onKeyUp(event) {
    switch (event.keyCode) {
      case 27: // escape key
        return this.closeEditor(false);
      default:
        return this.resizeEditor(this.myInputRef.current);
    }
  }

  updateContent(event) {
    var newContent;
    // replace all new lines with spaces if this is a single line input
    newContent = event.target.value;
    if (this.props.singleLine) {
      newContent = newContent.replace(/([\r\n])/g, " ");
    }
    return this.setState({
      rawContent: newContent,
    });
  }

  onFocus() {
    return this.resizeEditor(this.myInputRef.current);
  }
}
